export const SEND_SIGN_UP_EMAIL_FAILED_MESSAGE = "error:signUp.send-sign-up-email-failed"
export const VERIFY_SIGN_UP_CODE_FAILED_MESSAGE = "error:signUp.verify-sign-up-code-failed"
export const SIGN_UP_BY_EMAIL_FAILED_MESSAGE = "error:signUp.sign-up-by-email-failed"
